import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormulareService } from '../../formulare/formulare.service';
import { Auftrag } from '../../state/auftrag.model';

@Component({
  selector: 'app-dialog-checkliste-lkt-bioclear',
  templateUrl: './dialog-checkliste-lkt-bioclear.component.html',
  styleUrls: ['./dialog-checkliste-lkt-bioclear.component.scss'],
})
export class DialogChecklisteLktBioclearComponent implements OnInit {
  form: FormGroup;
  auftrag: Auftrag;

  constructor(@Inject(MAT_DIALOG_DATA) dialogData, formulareService: FormulareService) {
    const { formData = {}, auftrag } = dialogData;

    if (!auftrag) {
      throw new Error('Kein Auftrag!');
    }

    this.auftrag = auftrag;

    this.form = formulareService.checklisteBioClear();
    this.form.patchValue(formData);
  }

  ngOnInit() {}
}
